import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { CryptocurrencyCreateFormFields } from "web_myplann/Portfolio/Forms/CryptocurrencyForm/CryptocurrencyCreateFormFields";
import { useCreateCryptocurrencyForm } from "web_myplann/Portfolio/Forms/CryptocurrencyForm/useCreateCryptocurrencyForm";
import { PortfolioFormShell } from "web_myplann/Portfolio/PortfolioShared/PortfolioFormShell";

export const CreateCryptocurrencyForm = () => {
	const { t } = useResource();
	const { form, onSubmit, isPending } = useCreateCryptocurrencyForm();

	return (
		<PortfolioFormShell
			onSubmit={onSubmit}
			submitLabel={t(Resources.Portfolio.AddShared.submit)}
			disabled={!form.formState.isDirty}
			loading={isPending}
		>
			<CryptocurrencyCreateFormFields control={form.control} />
		</PortfolioFormShell>
	);
};
